import React, {type FC} from 'react';
import {IProduct} from '../../../../../types/galleryTypes';
import {useGlobals, withGlobals} from '../../../../../globalPropsContext';
import {MobileDrawer} from '@wix/wix-ui-tpa/cssVars';
import {ProductQuickAddContent} from '../ProductQuickAddContent/ProductQuickAddContent';
import s from './ProductQuickAddMobile.scss';
import {classes as mobileDrawerStylable} from './ProductQuickAddMobile.st.css';
import classNames from 'classnames';

export const ProductQuickAddMobileDataHooks = {
  Root: 'product-quick-add-mobile-root',
};
export interface IProductQuickAddMobileProps {
  product: IProduct;
  quantity: number;
}

const ProductQuickAddMobileComp: FC<IProductQuickAddMobileProps> = ({product, quantity}) => {
  const {closeQuickAdd, host} = useGlobals();

  return (
    <MobileDrawer
      isOpen={true}
      appendToBody={true}
      onRequestClose={/* istanbul ignore next */ () => closeQuickAdd(product.id)}
      className={classNames(host.id, mobileDrawerStylable.mobileDrawer)}
      data-hook={ProductQuickAddMobileDataHooks.Root}>
      <div className={classNames(s.stopBodyYScroll, s.quickAddMobileScrollContainer)}>
        <ProductQuickAddContent product={product} quantity={quantity} />
      </div>
    </MobileDrawer>
  );
};

export const ProductQuickAddMobile = withGlobals(ProductQuickAddMobileComp);
